import { Box, Text } from '@factorialco/deprecated-design-system'
import { capitalize } from 'lodash'

import { timeAgoWhenRecent } from 'modules/ats/lib/dates'
import type { Message } from 'modules/finance/hooks/useMessage'

interface Props {
  message: Message
}

const MessageHeader = ({ message }: Props) => {
  if (!message) return null

  const { from, subject, createdAt } = message

  const appliedDate = capitalize(timeAgoWhenRecent(createdAt))

  function formatFrom(from: string): { name: string; email: string } {
    const startIndex = from.indexOf('<')
    const endIndex = from.indexOf('>')

    if (startIndex !== -1 && endIndex !== -1) {
      const senderName = from.substring(0, startIndex).trim()
      const senderEmail = from.substring(startIndex + 1, endIndex).trim()
      if (senderName) {
        return { name: senderName, email: senderEmail }
      } else {
        return { name: '', email: senderEmail }
      }
    }
    return { name: '', email: from }
  }

  return (
    <Box width="full" flexDirection="column" paddingX="s24" paddingY="s12" gap="s8">
      <Box flexGrow flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal weight="medium" color="grey1000">
          {formatFrom(from).name || formatFrom(from).email}
        </Text.Normal>
        <Text weight="normal" color="grey800" size="200">
          {appliedDate}
        </Text>
      </Box>
      <Box flexGrow flexDirection="column" justifyContent="spaceBetween" gap="s8">
        <Text weight="normal" color="grey800" size="200">
          {subject}
        </Text>
        <Text weight="normal" color="grey800" size="200">
          From: {formatFrom(from).email}
        </Text>
      </Box>
    </Box>
  )
}

export default MessageHeader
